export const createConsoleUrl = (modulePath: string, customerPath?: string, params?: Record<string, string>) => {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const searchParams = params ? `?${new URLSearchParams(params)}` : '';
  const basePath = customerPath ? `/console/${customerPath}` : '/console';
  return `${basePath}/${modulePath}${searchParams}`;
};

export const createVideoUrl = (modulePath: string, customerPath?: string) => {
  const basePath = customerPath ? `/video/${customerPath}` : '/video';
  return `${basePath}/${modulePath}`;
};
